import { AxiosResponse } from "axios";

import axiosHttpClient from "@/axios-http-client";

import { AuthenticationCredentials } from "@/interfaces/authentication-credentials";
import { AuthenticationResponse } from "@/interfaces/authentication-response";
import { RequestConfig } from "@/interfaces/http/request-config";

import { RequestAlias } from "@/enums/request-alias.enum";
import { I18nStorageService } from "@/services/i18n-storage.service";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Authentication service
 */
export abstract class AuthenticationService {
  /**
   * Makes authentication request
   * @param credentials User authentication credentials
   */
  static authenticate(
    credentials: AuthenticationCredentials
  ): Promise<AxiosResponse<AuthenticationResponse>> {
    credentials.languageId = I18nStorageService.locale.toUpperCase();
    return axiosHttpClient.post<AuthenticationResponse>(
      "login/check",
      credentials,
      {
        requestAlias: RequestAlias.Authenticate
      } as RequestConfig
    );
  }

  /**
   * Makes token refresh request
   * @param refreshToken JWT refresh token
   */
  static refreshToken(
    refreshToken: string
  ): Promise<AxiosResponse<AuthenticationResponse>> {
    return axiosHttpClient.post<AuthenticationResponse>(
      "login/token/refresh",
      { refreshToken },
      {
        requestAlias: RequestAlias.RefreshToken
      } as RequestConfig
    );
  }
}
